import React from 'react';

const ClaveAgustinianaView = ({ onBack, onSectionClick }) => {
  // Definir las secciones con sus días correspondientes
  const secciones = [
    {
      id: 'pildoras-san-agustin',
      titulo: 'Píldoras de San Agustín',
      subtitulo: 'Martes',
      descripcion: 'Pensamientos breves del Doctor de la Gracia',
      icono: '💊',
      color: 'from-blue-500 to-blue-600',
      section: 'Píldoras de San Agustín'
    },
    {
      id: 'habla-san-agustin',
      titulo: 'Habla San Agustín',
      subtitulo: 'Miércoles',
      descripcion: 'Palabras del santo que transforman corazones',
      icono: '🗣️',
      color: 'from-green-500 to-green-600',
      section: 'Habla San Agustín'
    },
    {
      id: 'orando-san-agustin',
      titulo: 'Orando con San Agustín',
      subtitulo: 'Jueves',
      descripcion: 'Momentos de oración con el santo',
      icono: '🙏',
      color: 'from-purple-500 to-purple-600',
      section: 'Orando con San Agustín'
    },
    {
      id: 'historia-personas',
      titulo: 'Sabías que... San Agustín y los agustinos',
      subtitulo: 'Viernes',
      descripcion: 'Conoce la historia agustiniana',
      icono: '📚',
      color: 'from-amber-500 to-amber-600',
      section: ['Historia y personajes', 'Sabías que…']
    },
    {
      id: 'reflexion-agustiniana',
      titulo: 'Reflexión agustiniana',
      subtitulo: 'Sábados',
      descripcion: 'Profundiza en el pensamiento agustino',
      icono: '🤔',
      color: 'from-indigo-500 to-indigo-600',
      section: 'Reflexión agustiniana'
    },
    {
      id: 'domingo-san-agustin',
      titulo: 'Domingo con San Agustín',
      subtitulo: 'Domingos',
      descripcion: 'Reflexiones dominicales agustinianas',
      icono: '☀️',
      color: 'from-orange-500 to-orange-600',
      section: 'Domingo con San Agustín'
    },
    {
      id: 'santos-agustinos',
      titulo: 'Santos agustinos',
      subtitulo: 'Santoral',
      descripcion: 'Conoce a los santos de la familia agustiniana',
      icono: '👼',
      color: 'from-rose-500 to-rose-600',
      section: 'Santos Agustinos'
    }
  ];

  const handleCardClick = (seccion) => {
    console.log(`🔘 Navegando a: ${seccion.section}`);
    
    // Pasar información de que venimos desde ClaveAgustinianaView
    onSectionClick(seccion.section, { source: 'clave-agustiniana' });
  };

  return (
    <div className="app-container">
      <div className="content-container">
        
        {/* Header con navegación */}
        <div 
          className="absolute inset-x-0 top-0"
          style={{
            background: 'linear-gradient(to bottom, #c82318 0%, #c82318 15%, #a01916 100%)',
            height: 'calc(120px + env(safe-area-inset-top))',
            marginTop: 'calc(-1 * env(safe-area-inset-top))',
            zIndex: 1
          }}
        />
        
        <div 
          className="relative text-white px-5"
          style={{
            paddingTop: 'max(env(safe-area-inset-top), 0px)',
            paddingBottom: '20px',
            minHeight: 'calc(120px + env(safe-area-inset-top))',
            zIndex: 10,
            background: 'linear-gradient(to bottom, #c82318 0%, #c82318 15%, #a01916 100%)'
          }}
        >
          <div className="flex items-center justify-between" style={{ paddingTop: '15px', marginBottom: '20px' }}>
            {/* Botón de atrás */}
            <button
              onClick={onBack}
              className="w-9 h-9 rounded-xl flex items-center justify-center bg-white bg-opacity-20 backdrop-blur-sm text-white hover:bg-opacity-30 transition-all"
            >
              ←
            </button>
            
            {/* Título */}
            <h1 className="text-3xl font-bold mb-2 text-center">
            {/* </h1> className="text-lg font-semibold text-center flex-1 mx-4"> */}
              Clave agustiniana
            </h1>
            
            {/* Espacio para simetría */}
            <div className="w-9 h-9"></div>
          </div>
          
          {/* Subtítulo */}
          <div className="text-center">
            <p className="text-white/90 text-sm italic font-medium">
              "Con corazón inquieto hasta que descanse en Ti"
            </p>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="px-5 py-8 bg-white">
          
          {/* Grid de tarjetas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {secciones.map((seccion) => (
              <div
                key={seccion.id}
                onClick={() => handleCardClick(seccion)}
                className="modern-card cursor-pointer hover:transform hover:-translate-y-1 transition-all duration-300 group"
              >
                {/* Header de la tarjeta */}
                <div className="flex items-center gap-3 mb-4">
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl group-hover:scale-110 transition-transform duration-300"
                    style={{
                      background: 'linear-gradient(135deg, #e62c19 0%, #a01916 100%)'
                    }}
                  >
                    {seccion.icono}
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-gray-800 group-hover:text-red-600 transition-colors">
                      {seccion.titulo}
                    </h3>
                    <span className="text-sm text-gray-500 font-medium">
                      {seccion.subtitulo}
                    </span>
                  </div>
                </div>
                
                {/* Descripción */}
                <p className="text-sm text-gray-600 leading-relaxed">
                  {seccion.descripcion}
                </p>
                
                {/* Indicador de navegación */}
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-100">
                  <span className="text-xs text-gray-400 font-medium">
                    Ver contenido
                  </span>
                  <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center group-hover:bg-red-100 transition-colors">
                    <span className="text-xs text-gray-500 group-hover:text-red-600">→</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Mensaje informativo */}
          <div className="mt-8 p-4 bg-gradient-to-r from-red-50 to-red-100 rounded-xl border border-red-200">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0 mt-1">
                <span className="text-white text-sm">ℹ️</span>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-red-800 mb-1">
                  Contenido programado
                </h4>
                <p className="text-xs text-red-700 leading-relaxed">
                  Cada sección se actualiza en su día correspondiente de la semana con nuevo contenido agustiniano para acompañar tu crecimiento espiritual.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Padding bottom para navegación */}
        <div style={{ height: '80px' }}></div>
      </div>
    </div>
  );
};

export default ClaveAgustinianaView;